const config = {
    // API_BASE_URL: "https://localhost:44342",
    API_BASE_URL: "https://mbssslsuppapi.bigxam.com",
    // API_BASE_URL: "https://mbose-supplementary.cludocloud.com/api",
  };
  
  export default config;
  